import { NavLink, Outlet } from 'react-router-dom';
import './settings.css';
import './settingsForms.css';

export function SettingsLayout() {
  return (
    <div className="settings-layout">
      <nav className="settings-tabs" aria-label="Nastavitve">
        <NavLink end to="/nastavitve">
          Uporabniki
        </NavLink>
        <NavLink to="/nastavitve/tagi">Tagi</NavLink>
        <NavLink to="/nastavitve/splosno">Splošno</NavLink>
        <NavLink to="/nastavitve/stroski">Stroški</NavLink>
        <NavLink to="/nastavitve/regali">Prostori in mesta</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
